import type { BoxProps } from '@mui/material/Box';
import MUIDialogContent, {
  type DialogContentProps as MUIDialogContentProps,
} from '@mui/material/DialogContent';
import { forwardRef } from 'react';
import { LoadingPlaceholderContainer } from '../loading-placeholder';

export type DialogContentProps = MUIDialogContentProps & {
  isLoading?: boolean;
  LoadingContainerProps?: BoxProps;
};

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  ({ isLoading, LoadingContainerProps, ...props }, ref) => {
    return (
      <LoadingPlaceholderContainer
        {...LoadingContainerProps}
        isLoading={!!isLoading}
        sx={{
          position: 'relative',
          minHeight: 320,
          ...LoadingContainerProps?.sx,
        }}
      >
        <MUIDialogContent ref={ref} {...props} />
      </LoadingPlaceholderContainer>
    );
  },
);

if (process.env.NODE_ENV === 'development') {
  DialogContent.displayName = 'DialogContent';
}
